<!-- INFO: component with custom css -->
<div class="top-navigation" nz-flex nzAlign="center">
  @if (showBackButton) {
    <button
      nz-button
      nzSize="large"
      class="ps-3.5 pe-3 py-2 text-lg md:ps-0 md:pe-2 md:py-0"
      nzType="link"
      (click)="onGoBack()"
      nz-icon
      [nzType]="backIcon"
      nzTheme="outline"
    ></button>
  }
  <div class="title-container w-full me-10" nz-flex>
    <h2 nz-typography class="block min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap">{{ title }}</h2>
  </div>
  <div class="md:hidden">
    <app-header-actions></app-header-actions>
  </div>
</div>
